import { ChartDef } from '@model-main/pivot/frontend/model/chart-def';

export const ValuesInChartOverlappingStrategy = {
    AUTO: ChartDef.ValuesInChartOverlappingStrategy.AUTO,
    ALL: ChartDef.ValuesInChartOverlappingStrategy.ALL
}
